import { render, staticRenderFns } from "./PackageCalc.vue?vue&type=template&id=4b763843&scoped=true"
import script from "./PackageCalc.vue?vue&type=script&lang=ts"
export * from "./PackageCalc.vue?vue&type=script&lang=ts"
import style0 from "./PackageCalc.vue?vue&type=style&index=0&id=4b763843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b763843",
  null
  
)

export default component.exports